/**
 * OVERRIDE LinkView.jsx
 */

import LinkView from '../../../../components/View/LinkView';

export default LinkView;